import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * ai 报警列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	getAiListApi( params={} ) {
		return request({
	    url: baseUrl + '/device/getCameraForAi',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * ai 最新报警
	**/
	aiNewListApi(params={}) {
		return request({
		url: baseUrl + '/device/getWindowForAi',
		method: 'GET',
		params
	  })
	},
	/**
	 * ai 报警 处理
	 * @param {alarm_id} 报警id
	**/
	aiUpdateWarn(id,data){
		return request({
			url: baseUrl + '/device/updateWindowForAi/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * ai 报警详情
	 * @param {lampId} 报警id
	**/
	getAiInfo(id) {
		return request({
	    url: baseUrl + '/device/getInfoForAi/'+id,
	    method: 'GET'
	  })
	}
}